import { ChangeEvent } from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { capitalizeFirstLetter } from './Number.util'
import { IModule, ISubModule } from '../models/store.model'

dayjs.extend(utc)

export const removeEmptyValuesFromObject = (obj: { [key: string]: any }) => {
  Object.keys(obj).forEach((key) => obj[key] === undefined || (obj[key] === '' && delete obj[key]))
  return obj
}

export const parseFloatStr = (str: string, val: number) => {
  str = str.toString()
  if (str.indexOf('.') === -1) {
    return Number(str)
  }
  str = str.slice(0, str.indexOf('.') + val + 1)
  return Number(str)
}

export const noSpecialCharacterFormat = (event: ChangeEvent, limit: number = 500): string => {
  const input = event.target as HTMLInputElement
  let v = input.value
  if (v) {
    const containSpecialCharacter = /[!@#$%^&*)(+=.<>{}[\]:;"|~`_\-/?]/g
    if (containSpecialCharacter.test(v)) {
      return v.replace(containSpecialCharacter, '')
    } else {
      return v.substring(0, limit)
    }
  } else {
    return ''
  }
}

export const showAsUSCurrencyFormat = (amount: number | string = '') =>
  amount?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })

export const tableBodyHeights = {
  commonTable: 'calc(100vh - 410px - 175px)',
  sixItemsTable: 450,
  pageDividedTable: 364,
}

export const shouldDisableStartDate = (toDate: any, current: any) => {
  return (toDate && current && current > toDate) || current > dayjs().endOf('day')
}

export const shouldDisableToDate = (startDate: any, current: any) => {
  return (startDate && current && current < startDate) || current > dayjs().endOf('day')
}

export const showShortContentWithThreeDots = ({
  value,
  prefixLength,
  postfixLength,
}: {
  value: string
  prefixLength: number
  postfixLength: number
}) => {
  const threeDotsLength = 3
  if (value.length <= prefixLength + postfixLength + threeDotsLength) {
    return value
  }
  const lastItemIndex = value.length
  return `${value.substring(0, prefixLength)}...${value.substring(lastItemIndex - postfixLength, lastItemIndex)}`
}

export const sortByOrder = (list: any, field?: any) => {
  if (field) {
    return list.sort((a: any, b: any) => a[field] - b[field])
  }
  return list.sort((a: any, b: any) => a.position - b.position)
}

export const transferToBlob = (rawData: string) => {
  const byte = atob(rawData)
  const byteNumber = new Array(byte.length)
  for (let i = 0; i < byte.length; i++) {
    byteNumber[i] = byte.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumber)
  const blob = new Blob([byteArray], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  return blob
}

export const transferToBlobWithFileType = (rawData: string, fileType: string) => {
  const byte = atob(rawData)
  const byteNumber = new Array(byte.length)
  for (let i = 0; i < byte.length; i++) {
    byteNumber[i] = byte.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumber)
  const blob = new Blob([byteArray], {
    type: fileType,
  })

  return blob
}

export const downloadBlob = (blob: any, fileName: string) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  URL.revokeObjectURL(url)
  document.body.removeChild(link)
}
export const getPayload = (
  searchTerm?: string,
  searchColumns?: string[],
  isDesc?: boolean,
  sortColumns?: string[],
  pageSize?: number,
  pageIndex?: number,
) => {
  return {
    searchTerm,
    searchColumns,
    isDesc,
    sortColumns,
    pageSize: null,
    pageIndex: 1,
    filterOption: 0,
  }
}

export const getActiveAll = (data: IModule[]) => {
  const arrays = data?.map((module) => module.submoduleItemShortInfos)
  const empty: ISubModule[] = []
  return empty?.concat(...arrays).map((i: ISubModule) => i.submoduleItemId)
}

export const numberWithCommas = (x: string) => {
  x = x.toString()
  let pattern = /(-?\d+)(\d{3})/
  while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
  return x
}

export const convertAllSecCode = (lookupValuesSECCode: any, isAllTransactionPage = false) => {
  let data = []
  const position = lookupValuesSECCode?.findIndex((item: any) => item.value === 'ALL')
  if (position !== -1) {
    const all = lookupValuesSECCode[position] as any
    const ALL = {
      ...all,
      value: ' ALL SEC CODES',
    }
    data = lookupValuesSECCode?.filter((item: any) => item.value !== 'ALL')
    !isAllTransactionPage && data.unshift(ALL)
  } else {
    data = lookupValuesSECCode
  }

  return data
}

export const handleCheckSecCodeAll = (value: any) => {
  const SEC_ALL = value?.filter((sec: any) => sec?.label.includes(' ALL SEC CODES'))[0]
  if (value[value.length - 1]?.label.includes(' ALL SEC CODES')) {
    return [SEC_ALL]
  } else {
    return value?.filter((sec: any) => !sec?.label.includes(' ALL SEC CODES'))
  }
}

export const StringSetAsArray = (arr: any) => {
  return Array.from(new Set(arr)) ?? []
}
